// extracted by mini-css-extract-plugin
module.exports = {"tv":"_3OD_XNk4faMg8EN960uaET"};